<style>
    .sample-label {
        position: absolute !important;
        background-color:rgba(0, 0, 0, 0) !important;
        border-color:rgba(0, 0, 0, 0) !important;
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        box-shadow: none !important;
    }
    
    .leaflet-tooltip-top:before,
    .leaflet-tooltip-bottom:before,
    .leaflet-tooltip-left:before,
    .leaflet-tooltip-right:before {
        position: absolute !important;
        pointer-events: none !important;
        border: 6px solid transparent !important;
        background: transparent !important;
        content: "" !important;
    }

    .info {
        padding: 6px 8px;
        background: white;
        background: rgba(255,255,255,0.6);
        box-shadow: 0 0 5px rgba(0,0,0,0.1);
        border-radius: 5px;
    }

    .info h4 {
        margin: 0 0 5px;
        color: #777;
    }
</style>
<template>
	<div>
		<div class="flex py-2 m-2 px-4">
			<div class="flex-1 text-left">
				<p class="text-lg font-extrabold">Välj samlingsprov som ska läggas till på pappret</p> 
				<p class="text-md font-light mt-2" v-text="customer.id + ' ' + customer.title"></p>
				<p class="text-sm font-thin mt-2">Klicka på ett samlingsprov för att välja det. Klicka på hämta bakgrundskarta och använd sen ritverktyget för att välja bakgrundskarta. När du valt dina samlingsprov och din bakgrundskarta klicka på knappen "Lägg till valda samlingsprov".</p>
			</div>
			<div class="flex-1">
				<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
					<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
				</button>
			</div>
		</div>
        <div id="map" class="h-screen-75 border-t border-b border-grey-light">

			<div v-if="selectedCollectionSamplePolygons.length" class="absolute pin-r pin-t mt-12 z-leaflet">
				<button @click="addCollectionSamplesToPage()" class="flex items-center w-35 py-2 mt-4 ml-6 pr-2 pl-2 mr-2 text-sm text-center text-white bg-blue hover:bg-blue-dark rounded shadow-light font-bold">
					+ Lägg till valda samlingsprov
				</button>
			</div>

			<div class="absolute bg-grey-lightest pin-l pin-t mt-2 border ml-16 z-leaflet shadow-lg rounded-lg overflow-hidden">
				<div class="px-6 pt-4 mb-4">
					<label class="ml-2 checkbox-container">
						<input type="checkbox" v-model="useBackgroundMap">
						<span class="checkmark"></span>
						<span class="checkmark-text font-bold">Hämta bakgrundskarta</span>
					</label>
				</div>
			</div>

			<div v-if="backgroundPolygon" class="absolute pin-r pin-b mb-6 z-leaflet">
				<button @click="clearBackgrundPolygon()" class="flex items-center w-35 py-2 mt-4 ml-6 pr-2 pl-2 mr-2 text-sm text-center text-white bg-red hover:bg-red-dark rounded shadow-light font-bold">
					Rensa markerad bakgrundskarta
				</button>
			</div>
		</div>

	<div class="w-full bg-grey-lightish rounded-b pb-16">
		<div class="float-left ml-4 mt-4">
			<button @click="goBack()" class="items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white block bg-grey-dark hover:bg-grey-darker rounded shadow-light font-bold">
				<svg class="text-white fill-current w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>
				Välj annan order
			</button>
		</div>
	</div>

	</div>
</template>

<script>

import axios from 'axios'
import uuid from 'uuid';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-imageoverlay-rotated';
import layerContainsPolygon from '@turf/boolean-contains';
import flattenMultiPolygon from '@turf/flatten';

import interpolationImages from '@/mixins/interpolationImages';
import selectablePolygons from '@/mixins/selectablePolygons';

import { mapGetters } from 'vuex'

export default {
	name: 'CollectionSamplesMap',
	props: ['page_id'],
	mixins: [interpolationImages, selectablePolygons],
	
	data() {
		return {
			map: null,

			collectionSamplesGeoJson: [],
			polygonsGeojson: null,
			selectedPolygons: [],
			drawnItems: [],

			useBackgroundMap: false,
			backgroundPolygon: null,
			selectedTileLayer: {
				current: null,
				selectedByUser: 'Lantmäteriet',
				layerChanged: false,
			},

			tileLayers: {
                "Lantmäteriet": L.tileLayer('https://api.lantmateriet.se/open/topowebb-ccby/v1/wmts/token/d17d5440-d4cb-3b2b-93cd-2c491b6f69f5/?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=topowebb_nedtonad&STYLE=default&TILEMATRIXSET=3857&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/png'),
                "Karta": L.tileLayer('https://api.mapbox.com/styles/v1/simtrax/civ4agfq7000m2ilcp4c87hot/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2ltdHJheCIsImEiOiI4ZjhhODc3ZjA5NDg4YmUyOWI5N2I1ODkxYjJkMGMwMCJ9.z3UUzcUcCZWVqBIvuhsQoQ', {attribution: '<a href="https://www.mapbox.com/about/maps/">© MapBox</a> | <a href="http://openstreetmap.org/copyright">© OpenStreetMap</a> | <a href="http://mapbox.com/map-feedback/" class="mapbox-improve-map">Improve this map</a>'}),
                "Flygfoto": L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'})
			}
		}
	},

	computed: {

		...mapGetters({
			customer:		'customer/customer',
			order:			'customer/order',
		}),

		collectionSamples() {
			let properties
			return this.order.collection_samples.map(polygon => {
				properties = {}
				Object.keys(polygon).forEach(key => {
					if(key !== 'geometry') {
						properties[key] = polygon[key]
					}
				})
				return {
					type:"Feature",
					geometry: JSON.parse(polygon.geometry),
					properties: properties
				}
			})
		},

		polygons() {
			let properties
			return this.order.polygons.map(polygon => {
				properties = {}
				Object.keys(polygon).forEach(key => {
					if(key !== 'geometry') {
						properties[key] = polygon[key]
					}
				})
				return {
					type:"Feature",
					geometry: JSON.parse(polygon.geometry),
					properties: properties
				}
			})
		},

		selectedCollectionSamplePolygons() {
			return this.selectedPolygons.filter(p => {
				return p.feature.properties.hasOwnProperty('color') && p.feature.properties.hasOwnProperty('title')
			})
		}
	},

	mounted() {
		this.initiateMap()

		this.addData()
	},

    beforeDestroy() {
		if(this.map) {
            this.map.remove()
        }
    },

	methods: {

		/**
		 * 	Send the selected polygons to the current page.
		 * 	Send all samples, and mark which ones are inside one of the selected polygons
		 */
		addCollectionSamplesToPage() {
			let params = {
				id: this.page_id, 
				backgroundPolygon: this.backgroundPolygon ? this.backgroundPolygon.toGeoJSON() : null,
			}

			let polygons = this.selectedPolygons.map(polygon => {
				return polygon.toGeoJSON()
			})
			let collectionPolygons = polygons.filter(p => {
				return p.properties.hasOwnProperty('color') && p.properties.hasOwnProperty('title')
			})
			let backgroundPolygons = polygons.filter(p => {
				return p.properties.hasOwnProperty('blockid') && p.properties.hasOwnProperty('areal')}
			)

			if(collectionPolygons.length) {
				params.featureCollection = {
					features: collectionPolygons,
					type: "FeatureCollection"
				}
			}
			if(backgroundPolygons.length) {
				params.backgroundFeatureCollection = {
					features: backgroundPolygons,
					type: "FeatureCollection"
				}
			}

			bus.$emit('add-collection-samples-to-page', params)
		},

		/**
		 * 	Will clear the year-attribute in the store which
		 * 	will redicect the user to the sampling-index view
		 */
		goBack() {
			this.$store.dispatch("customer/SET_ORDER", null)
		},

        /**
        *   Initiate the leaflet map
        *
        */
        initiateMap() {
            this.map = L.map('map', {
                layers: [this.tileLayers.Lantmäteriet],
                maxZoom: 18,
			})

			L.control.scale({imperial: false, maxWidth: 200}).addTo(this.map);

			let controller = L.control.layers(this.tileLayers).addTo(this.map)
			controller._layersLink.id = 'layer-selector'

            // Ritade figurer sparas här
			this.drawnItems = L.featureGroup()
			this.map.addLayer(this.drawnItems)

            // "Ritverktygen" läggs till på kartan
            this.map.addControl(new L.Control.Draw({
                edit: {
					featureGroup: this.drawnItems,
					remove:false,
                },
                draw: {
                    polyline: false,
                    polygon: false,
                    circle: false,
                    point: false,
                    rectangle: true,
                    marker: false,
                    layers: false,
                    circlemarker: false,
                }
			}))

			// After a polygon has been drawn, it will check what polygons are within the polygon
			this.map.on(L.Draw.Event.CREATED, event => this.layerDrawn(event, event.layer))
			this.map.on('draw:edited', event => this.layerEdited(event))

			this.map.on('zoomend', e => {
				this.changeLayers()
			});

			this.map.on('baselayerchange', e => {
				// Register if the user changed the layer
				if(e && !this.selectedTileLayer.layerChanged) {
					this.selectedTileLayer.selectedByUser = e.name
				}
				this.selectedTileLayer.layerChanged = false
			})

		},

		/**
		 * Will change the tileLayer if the zoom is larger than 15
		 * and if the layer is 15 or less the layer will change back
		 * to the users choice
		 */
		changeLayers() {
			if (this.map.getZoom() > 15) {
				if(this.selectedTileLayer.current !== 'Flygfoto') {
					this.selectedTileLayer.layerChanged = true
					if(this.selectedTileLayer.current) {
						this.map.removeLayer(this.tileLayers[this.selectedTileLayer.selectedByUser]);
					}
					this.map.addLayer(this.tileLayers.Flygfoto);
					this.selectedTileLayer.current = 'Flygfoto'
				}
			} else {
				if(this.selectedTileLayer.current === 'Flygfoto' && this.selectedTileLayer.selectedByUser !== 'Flygfoto') {
					this.selectedTileLayer.layerChanged = true
					this.map.removeLayer(this.tileLayers[this.selectedTileLayer.current]);
					this.map.addLayer(this.tileLayers[this.selectedTileLayer.selectedByUser]);
					this.selectedTileLayer.current = this.selectedTileLayer.selectedByUser
				}
			}
		},

		layerDrawn(event, layer) {
			let selectedPolygons = []

			this.selectCollectionSamplesInsidePolygon(layer)

			if(this.useBackgroundMap) {
				let item = layer

				if(event.layerType == 'polygon') {
					item = L.rectangle(layer.getBounds())
				}

				item.setStyle({
					color: "blue",
					weight: 3,
					opacity: 0.9,
					fillOpacity: 0,
					fillColor: "blue"
				})
				this.drawnItems.addLayer(item)
				this.polygonsGeojson.bringToBack()
				this.drawnItems.bringToBack()
				this.backgroundPolygon = item
			}
		},

		layerEdited(event) {
			event.layers.eachLayer(layer => {
				if(!layer.feature) {
					this.selectCollectionSamplesInsidePolygon(layer)
				}
			})
		},

		selectCollectionSamplesInsidePolygon(layer) {
			this.collectionSamplesGeoJson.eachLayer(polygon => {
				if(layerContainsPolygon(layer.toGeoJSON(), polygon.feature)) {
					let polygonAlreadySelected = this.selectedPolygons.some(polygon => {
						return polygon.feature.properties.id === polygon.feature.properties.id
					})
					if(!polygonAlreadySelected) {
						setTimeout(() => { 
							this.userSelectedAPolygon(polygon, false, this.getPolygonStyle(polygon.feature))
						}, 1);
					}
				}
			})

			this.polygonsGeojson.eachLayer(polygon => {
				if(layerContainsPolygon(layer.toGeoJSON(), polygon.feature)) {
					let polygonAlreadySelected = this.selectedPolygons.some(polygon => {
						return polygon.feature.properties.id === polygon.feature.properties.id
					})
					if(!polygonAlreadySelected) {
						setTimeout(() => { 
							this.userSelectedAPolygon(polygon, false)
						}, 1);
					}
				}
			})
		},

        /**
         *  Adds the samples and the polygons to the map
         */
        addData() {
			this.addCollectionSamples()
			this.addPolygons(this.polygons)

			// Add the polygons to the drawnItems layer so that they can be edited
			this.collectionSamplesGeoJson.eachLayer(layer => {
				this.drawnItems.addLayer(layer)
			})
		},

        /**
         *   Add the polygons to the map
         *   When added fit the map bounds to the polygon outer bounds
         */
        addCollectionSamples() {
			let style
			this.collectionSamplesGeoJson = L.geoJson(null, {
				onEachFeature: (feature, layer) => {
					((layer, properties) => {
						style = this.getDefaultPolygonStyle()
						style.fillColor = feature.properties.color
						style.fillOpacity = 0.7
						layer.setStyle(style)
					})(layer, feature.properties);

					layer.feature.properties.id = uuid.v4()

					layer.on("click", event => {
						let panToPolygon = false
						this.userSelectedAPolygon(layer, panToPolygon, this.getPolygonStyle(layer.feature))
					});
				}
			}).addTo(this.map);

			this.collectionSamples.forEach(multiPolygon => {
				flattenMultiPolygon(multiPolygon).features.forEach(polygon => {
					this.collectionSamplesGeoJson.addData(polygon)
				})
			})

			this.map.fitBounds(this.collectionSamplesGeoJson.getBounds())

            this.initiateMapListener()
		},

        /**
         *   Add the polygons to the map
         *   When added fit the map bounds to the polygon outer bounds
         */
        addPolygons(polygons) {
            if(polygons) {
                this.polygonsGeojson = L.geoJson(null, {
                    onEachFeature: (feature, layer) => {
                        ((layer, properties) => {
                            layer.setStyle(this.getDefaultPolygonStyle())
                        })(layer, feature.properties);
                        layer.feature.properties.id = uuid.v4()
						layer.on("click", event => {
							let panToPolygon = false
							this.userSelectedAPolygon(layer, panToPolygon)
						});
                    }

				}).addTo(this.map);

				polygons.forEach(multiPolygon => {
					flattenMultiPolygon(multiPolygon).features.forEach(polygon => {
						this.polygonsGeojson.addData(polygon)
					})
				})

                this.map.fitBounds(this.polygonsGeojson.getBounds())
				this.polygonsGeojson.bringToBack()
            } else {
                // We try to make sure that the samples are loaded by waiting 500 ms
                setTimeout(() => {
                    this.map.fitBounds(this.collectionSamplesGeoJson.getBounds());
                }, 500)
            }

            this.initiateMapListener()
        },

        /**
        *   Removes previously selected polygon
        */
        removeLayer(layer) {
            this.map.removeLayer(layer);
        },

		clearBackgrundPolygon() {
			this.backgroundPolygon.removeFrom(this.map)
			this.backgroundPolygon = null
		},

		getPolygonStyle(feature) {
			return {
				clicked: {
					fillColor: feature.properties.color,
					fillOpacity: 0.7
				},
				default: {
					fillColor: feature.properties.color,
					fillOpacity: 0.7
				}
			}
		},

		dismissModal() {
			this.$emit('closeModal')
		}

	}
}
</script>